import { useQuery } from '@tanstack/react-query';
import { useComplianceApi } from 'core/Api';

type holidayPromotion = {
  goal: number;
  raised_so_far: number;
  count_of_action: number;
  days_left: number;
  recent_activity: {
    name: string;
    initials: string;
    tagline: string;
    time_ago: string;
    uuid: string;
  }[];
};
const useGetHolidayPromotion = () => {
  const ComplianceApi = useComplianceApi();
  const get = async () => {
    const { data } = await ComplianceApi.get<holidayPromotion>(`/promotions/holiday`);
    return data;
  };

  return useQuery({
    queryKey: ['holidayPromotion'],
    queryFn: get,
  });
};

export { useGetHolidayPromotion };
